import { render, staticRenderFns } from "./flightDetails.vue?vue&type=template&id=189749a0&scoped=true&"
import script from "./flightDetails.vue?vue&type=script&lang=js&"
export * from "./flightDetails.vue?vue&type=script&lang=js&"
import style0 from "./flightDetails.vue?vue&type=style&index=0&id=189749a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189749a0",
  null
  
)

export default component.exports